module.exports = __webpack_public_path__ + "img/kakao.4ea088d7.jpg";